import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-list",
  "use": "icon-list-usage",
  "viewBox": "0 0 15 19",
  "content": "<symbol viewBox=\"0 0 15 19\" id=\"icon-list\">\n  <path d=\"M1864,1401h-13a1,1,0,0,1-1-1v-14a1.033,1.033,0,0,1,.29-0.71l3-3a0.99,0.99,0,0,1,.71-0.29h10a1,1,0,0,1,1,1v17A1,1,0,0,1,1864,1401Zm-10-16.59-1.59,1.59H1854v-1.59Zm9-.41h-7v3a1,1,0,0,1-1,1h-3v11h11v-15Zm-2,7h-7v-2h7v2Zm0,3h-7v-2h7v2Zm0,3h-7v-2h7v2Z\" transform=\"translate(-1850 -1382)\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol